import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { SmtpAccountStatus, SmtpAccountsOverview, SmtpAccountUpdate } from "./type";

export const smtpAccountsLoader: LoaderFunction = async () => {
  const result = await axiosApi.get<Result<SmtpAccountsOverview>>("/api/smtpaccounts");
  return result.data;
};

export const updateSmtpAccount = (name: string, dto: SmtpAccountUpdate) =>
  axiosApi.put<Result<SmtpAccountStatus>>(`/api/smtpaccounts/${encodeURIComponent(name)}`, dto);

export const sendSmtpTestMail = (name: string, toEmail: string) =>
  axiosApi.post<Result<SmtpAccountStatus>>(`/api/smtpaccounts/${encodeURIComponent(name)}/test`, { toEmail });
